import {connect, useSelector} from "react-redux";

export const useAwsCopilotJustPaidGuard = (route=null) => {
    const user = useSelector(state => state.users.user)
    const awsSubscription = user?.all_aws_live_subscriptions;
    console.log("AWS AWS", awsSubscription)

    return awsSubscription ? !awsSubscription.subscription_expired : false;
}
